import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query'
import { monitorException, setMonitoredContext } from '@BUP/services/monitor'
import { reportErrorOnce } from '@BUP/services/monitor/reportErrorOnce'
import { isFinanceWriteBlocked } from '@BUP/services/Axios/activeRole'

export const onQueryError = (error, query) => {
  // A FINANCE-blocked write never reaches the network; skip the monitor
  // report so blocked attempts do not spam Sentry (design D2).
  if (isFinanceWriteBlocked(error)) return
  reportErrorOnce(error, () => {
    setMonitoredContext('react-query', { scope: 'query', key: query.queryKey, meta: query.meta })
    monitorException(error)
  })
}

export const onMutationError = (error, variables, context, mutation) => {
  if (isFinanceWriteBlocked(error)) return
  reportErrorOnce(error, () => {
    setMonitoredContext('react-query', {
      scope: 'mutation',
      key: mutation.options?.meta?.mutationKey,
      variables,
      context
    })
    monitorException(error)
  })
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: onQueryError
  }),
  mutationCache: new MutationCache({
    onError: onMutationError
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // cache fresco por 5 minutos
      gcTime: 5 * 60 * 1000, // mantiene el cache 5 min después de inactividad
      refetchOnWindowFocus: false, // evita refetch al volver a la pestaña
      refetchOnMount: false, // evita refetch al remontar componente
      refetchOnReconnect: true, // permite refetch si vuelve la conexión
      retry: 1, // reintenta solo una vez si falla
      mutations: { retry: false, meta: { reportToSentry: true } }
    }
  }
})

export default queryClient
